import script from "./FMSIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./FMSIndex.vue?vue&type=script&setup=true&lang=js"

import "./FMSIndex.vue?vue&type=style&index=0&id=347b505e&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/qc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347b505e"]])

export default __exports__